const lenis = new Lenis({
  wrapper: document.body,
  smoothTouch: true,
});
window.__lenis = lenis;

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

document.addEventListener("alpine:init", () => {
  /* SPLASH SCREEN */
  Alpine.data("splash", () => ({
    hasInit: false,
    randIntro: 0,
    playIntro: false,
    init() {
      // Remove protocol and port
      var referrerParts = document.referrer.split("/");

      var referrerHost =
        referrerParts.length > 1
          ? document.referrer.split("/")[2].split(":")[0]
          : "";
      var isNewVisit = referrerHost != window.location.hostname;

      this.randIntro =
        window.splashVideos[
          Math.floor(Math.random() * window.splashVideos.length)
        ];

      if (isNewVisit) {
        setTimeout(document.documentElement.classList.add("splash-open"), 500);
        setTimeout(() => {
          this.close();
        }, 6000);

        this.playIntro = true;
      } else {
        this.playIntro = false;
        document.documentElement.classList.add("splash-skip");
      }

      this.hasInit = true;
    },
    close() {
      document.documentElement.classList.add("splash-complete");
    },
  }));

  /* CART NOTES */
  Alpine.data("cartNotes", () => ({
    note: "",
    updateTimeout: null,
    isUserTyping: false,
    userTypingTimeout: null,
    lastSentValue: "",

    init() {
      // Get initial value from textarea or cart
      const textarea = this.$el.querySelector("textarea");
      if (textarea) {
        // Get value from textarea content (for cart page) or value attribute (for drawer)
        this.note = textarea.value || textarea.textContent?.trim() || "";
        this.lastSentValue = this.note;
      }

      // Listen for cart updates to sync note value when cart is updated via ajax
      if (typeof jQuery !== "undefined") {
        jQuery(document).on("cart.requestComplete", (event, cart) => {
          if (cart && cart.note !== undefined && !this.isUserTyping) {
            const cartNote = cart.note || "";
            // Only update if textarea is empty or if cart note is different
            if (this.note === "" || (cartNote !== this.note && cartNote !== "")) {
              this.note = cartNote;
              this.lastSentValue = cartNote;
              // Update textarea if it exists
              const textarea = this.$el.querySelector("textarea");
              if (textarea) {
                textarea.value = cartNote;
              }
            }
          }
        });
      }
    },

    markUserTyping() {
      this.isUserTyping = true;
      clearTimeout(this.userTypingTimeout);
      // Reset typing flag after 1 second of no input
      this.userTypingTimeout = setTimeout(() => {
        this.isUserTyping = false;
      }, 1000);
    },

    updateNote() {
      this.markUserTyping();
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(() => {
        this.saveNote();
      }, 500); // 500ms debounce
    },

    saveNote() {
      this.lastSentValue = this.note;

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ note: this.note }),
      })
        .then((response) => response.json())
        .then((data) => {
          // Update CartJS if available
          if (typeof CartJS !== "undefined" && CartJS.cart) {
            CartJS.cart.note = data.note || this.note;
            // Trigger cart update event if CartJS supports it
            if (typeof jQuery !== "undefined") {
              jQuery(document).trigger("cart.requestComplete", [data]);
            }
          }
        })
        .catch((error) => {
          console.error("Error updating cart note:", error);
        });
    },

    onBlur() {
      clearTimeout(this.updateTimeout);
      this.isUserTyping = false;
      this.saveNote();
    },
  }));
});
